function MusicIntervalCard({ interval, visibility, restricted }) {
    const imagePath = "./images/" + interval + ".png";

    return (
        <div>
            {(visibility === "Show") && (!restricted) && <><img src={imagePath} alt={interval} width="128"></img><p>{interval}</p></>}
            {(visibility === "Show") && (restricted) && <><img src={imagePath} alt={interval} width="128" style={{ opacity: 0.5 }}></img><p>{interval}</p></>}
            {(visibility === "Hide") && (!restricted) && <img src="./images/Card Back.png" alt="Back of Card" width="128" height="82"></img>}  
            {(visibility === "Hide") && (restricted) && <img src="./images/Card Back.png" alt="Back of Card" width="128" height="82" style={{ opacity: 0.5 }}></img>}           
        </div>
    )
}

export default MusicIntervalCard